import { useContext } from 'react';

import MatchMediaContext from '../../providers/context/MatchMediaProvider/MatchMediaContext';

export const useMatchMedia = () => {
  const { isDesktop, isTablet, isMobile } = useContext(MatchMediaContext);

  return { isDesktop, isTablet, isMobile };
};
